import { render, staticRenderFns } from "./B2bbuypricesimport.vue?vue&type=template&id=766a7e84&scoped=true&"
import script from "./B2bbuypricesimport.vue?vue&type=script&lang=js&"
export * from "./B2bbuypricesimport.vue?vue&type=script&lang=js&"
import style0 from "./B2bbuypricesimport.vue?vue&type=style&index=0&id=766a7e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a7e84",
  null
  
)

export default component.exports